<div class="upgrade-plan-modal">
  <ng-container
    *ngLet="{
      mode: mode$ | async,
      title: modalTitle$ | async
    } as data"
  >
    <div class="flex items-center justify-between">
      <div class="upgrade-plan-title">{{ data.title }}</div>

      <button
        mat-icon-button
        class="mat-button mat-icon-button transition-color"
        (click)="closeDialog()"
      >
        <i class="fa fas fa-close"></i>
      </button>
    </div>

    <mat-dialog-content>
      <div class="upgrade-plan-subtitle" *ngIf="data.mode === ModalMode.Plans">
        {{ description }}
      </div>

      <div class="upgrade-plan-list">
        <koa-upgrade-plan-list
          [availableUpgrades]="availableUpgrades"
          [selectedPlan]="selectedPlan"
          (modeChange)="setMode($event)"
        ></koa-upgrade-plan-list>
      </div>
    </mat-dialog-content>
  </ng-container>
</div>
